import { Box, Typography } from '@mui/material';
import { num } from '../format';
import { useConversionPlatform } from '../hooks/useConversionPlatform';
import { COLORS, cardSx } from '../theme';

/**
 * Web Conversions Funnel (Impressions → Site Visits → Web Conversions →
 * Offline Sales).
 *
 * Gated on the same rule as the Conversion Funnel: one platform with
 * conversions, or nothing at all. Web conversions are attributed per platform
 * exactly like every other conversion, so a funnel covering several DSPs would
 * be adding numbers that were never counted the same way.
 *
 * This previously rendered a permanent "not yet wired" card. Removing that
 * placeholder from the Conversion Funnel while leaving one here two widgets
 * away was worse than either choice on its own — the page still had a slot that
 * never filled, and it was being read as a loading failure rather than as
 * "there is no data yet".
 *
 * Only the stage totals are absent until conversion ingestion lands (#4478);
 * the gate itself is live, so this fills in without further UI work.
 */
const WebConversionsFunnel = () => {
  const { platform, conversions, loading } = useConversionPlatform();

  if (loading || !platform) return null;

  return (
    <Box className='rv2-card' sx={{ ...cardSx, p: 3, display: 'flex', flexDirection: 'column', gap: 1 }}>
      <Typography variant='subtitle1' sx={{ fontWeight: 600, color: COLORS.text }}>
        Web Conversions Funnel · {platform}
      </Typography>
      <Typography variant='body2' sx={{ color: COLORS.muted }}>
        {num(conversions)} conversions attributed to {platform} for the current filters. Stage-by-stage breakdown (site
        visits, offline sales) populates once attribution data is ingested.
      </Typography>
    </Box>
  );
};

export default WebConversionsFunnel;
